import { getBorderWidth } from '$lib/global/helper/border';

import type { DividerLineStyle } from '$lib/types/Components/Divider/DividerContent';
import type { BrandBorderStyle, BrandBorderWidth, Theme } from '$lib/types/Theme';

export interface ResolvedDividerStyling {
    color: string;
    borderWidthClass: string | undefined;
    lineStyle: DividerLineStyle;
}

interface Params {
    customColor: string;
    lineStyle: DividerLineStyle | undefined;
    theme: Theme;
}

const resolveLineColor = (customColor: string, theme: Theme): string => {
    if (customColor && customColor !== 'transparent') {
        return customColor;
    }

    if (theme.border) {
        return theme.border;
    }

    return theme.fontColor;
};

const resolveLineStyle = (
    lineStyle: DividerLineStyle | undefined,
    theme: Theme,
): DividerLineStyle => {
    if (lineStyle) {
        return lineStyle;
    }

    if (theme.borderStyle) {
        return theme.borderStyle as BrandBorderStyle;
    }

    return 'hidden';
};

const resolveBorderWidthClass = (lineStyle: DividerLineStyle, theme: Theme): string | undefined => {
    if (lineStyle === 'hidden') {
        return '';
    }

    if (theme.borderWidth) {
        return getBorderWidth(theme.borderWidth as BrandBorderWidth);
    }

    return undefined;
};

export const resolveDividerStyling = ({
    customColor,
    lineStyle,
    theme,
}: Params): ResolvedDividerStyling => {
    const effectiveLineStyle = resolveLineStyle(lineStyle, theme);

    return {
        color: resolveLineColor(customColor, theme),
        borderWidthClass: resolveBorderWidthClass(effectiveLineStyle, theme),
        lineStyle: effectiveLineStyle,
    };
};
